<template>
    <div style="display: flex;flex-direction: column;">
        <!--不是最后一个元素 margin-bottom 设置 8px-->

        <value_item :title="$t('driver.行驶里程')" :value="drivingdata.Mileage" style="margin-bottom: 8px;" />
        <value_item :title="$t('driver.行驶时长')" :value="drivingdata.Duration" style="margin-bottom: 8px;" />
        <value_item :title="$t('driver.平均车速')" :value="drivingdata.Speed" style="margin-bottom: 8px;" />
        <value_item :title="$t('driver.百公里能耗')" :value="drivingdata.Consume" />
    </div>
</template>
<script>
import value_item from './value_item.vue'
export default {
    components: {
        value_item
    },
	props: {
		 drivingdata:{}
	},
}
</script>